import { render, staticRenderFns } from "./PageSettingsPaymentSystems.vue?vue&type=template&id=60d0b7dc&scoped=true&"
import script from "./PageSettingsPaymentSystems.vue?vue&type=script&lang=ts&"
export * from "./PageSettingsPaymentSystems.vue?vue&type=script&lang=ts&"
import style0 from "./PageSettingsPaymentSystems.vue?vue&type=style&index=0&id=60d0b7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0b7dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
